import { AppError } from '../../contracts/errors.js'
import { buildImageRequest } from './request-normalizer.js'
import { normalizeImageResponse } from './response-normalizer.js'

export function createImageApiClient({ fetchImpl = globalThis.fetch, timeoutMs = 120000 } = {}) {
  return {
    async generate(job, provider, { signal } = {}) {
      const request = buildImageRequest(job, provider)
      const controller = new AbortController()
      const timer = setTimeout(() => controller.abort(), timeoutMs)
      const abort = () => controller.abort()
      signal?.addEventListener?.('abort', abort, { once: true })
      try {
        const response = await fetchImpl(request.url, { method: 'POST', headers: request.headers, body: JSON.stringify(request.body), signal: controller.signal })
        if (!response.ok) throw Object.assign(new AppError(`provider.http.${response.status}`, `服务请求失败（${response.status}）`, { category: response.status >= 500 || response.status === 429 ? 'network' : 'request', retryable: response.status === 429 || response.status >= 500 }), { status: response.status })
        return normalizeImageResponse(await response.json())
      } catch (error) {
        if (controller.signal.aborted) throw new AppError('generation.timeout', '生成请求超时或已取消', { category: 'network', retryable: true, cause: error })
        throw error
      } finally {
        clearTimeout(timer)
        signal?.removeEventListener?.('abort', abort)
      }
    },
  }
}
